import axios from 'axios'
import { getApiBaseUrl } from './apiConfig'

export const fetchExpenseRegisterList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/expenseregister/getall`, {
    params: { UserId: userId }
  })
  return Array.isArray(response?.data?.data) ? response.data.data : []
}

export const fetchExpenseRegisterById = async ({ expenseRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/expenseregister/getbyid`, {
    params: { ExpenseRegisterId: expenseRegisterId }
  })
  return response?.data?.data ?? null
}

export const saveExpenseRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/expenseregister/save`, payload)
  return response?.data
}

export const deleteExpenseRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/expenseregister/delete`, payload)
  return response?.data
}
